<ng-content></ng-content>


// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lessons/lesson-remove-button/lesson-remove-button.component.ts.LessonRemoveButtonComponent.html